/* eslint-disable */

import React from "react";

import { useEffect, useState } from "react";
import {
  fetchGraphQL,
  fetchOrganisationDetailImagePost,
} from "../../../services/api-raindrop";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";
import { Form } from "react-router-dom";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";

const FormNewDetailMedia = ({ organisationId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [localCaption, setLocalCaption] = useState("");
  const [localImageUrl, setLocalImageUrl] = useState("");
  const [localFile, setLocalFile] = useState(null);

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchOrganisationDetailImagePost({
      organisationId: organisationId,
      file: localFile,
      caption: localCaption,
    })
      .then((response) => {
        console.log("🟢 (RD-783) - ", response);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="p-6 bg-color-dark-background-secondary">
      <h1 className="font-bold">Add a new Detail media</h1>
      <RaindropInput
        label={"caption"}
        value={localCaption}
        onChange={(e) => setLocalCaption(e.target.value)}
      />
      <RaindropInputFile
        setImageUrl={setLocalImageUrl}
        imageUrl={localImageUrl}
        label="Media label"
        onChange={(e) => setLocalFile(e.target.files[0])}
      />
      <RaindropButton
        title="Add Media"
        onClick={onSubmit}
        isLoading={isSubmitting}
      />
    </div>
  );
};

const CirrusDescription = ({ organisation, currentOrganisationUser }) => {
  const [isError, setIsError] = useState(false);

  const [pageOrganisation, setPageOrganisation] = useState(null);

  useEffect(() => {
    fetchGraphQL(`
          query {
            organisation(id: "${organisation.id}") {
              id
              name
              presignedUrlLogo
              descriptionShort
              descriptionLong
              tags
              organisationDetailMediaObjects {
                id
                caption
                media {
                  id
                  presignedUrl
                }
              }
              activityObjects {
                id
                heading
              }
            }
          }
        `)
      .then((result) => {
        if (result.errors) {
          console.error(result.errors);
          setIsError(true);
          return;
        }
        setPageOrganisation(result.data.organisation);
      })
      .catch(() => {
        setIsError(true);
      });
  }, [organisation]);

  return (
    <div className="flex flex-col w-full h-full">
      {pageOrganisation &&
        pageOrganisation.organisationDetailMediaObjects.map((m) => (
          <div
            key={m.id}
            className="flex flex-col items-center gap-4 p-4 rounded-lg shadow-md bg-color-dark-background-secondary mb-6"
          >
            <img
              src={m.media.presignedUrl}
              alt={m.caption}
              className="w-24 h-auto object-cover rounded-lg"
            />
            <p className="text-lg text-gray-700 font-medium">{m.caption}</p>
          </div>
        ))}

      <FormNewDetailMedia organisationId={organisation.id} />
      {isError && <div>Op, there's an error.</div>}
    </div>
  );
};

export default CirrusDescription;
